.page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  padding: var(--sp-6);
  background: var(--bg);
  color: var(--text);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

.title {
  margin: 0;
  font-size: var(--fs-xl);
  font-weight: 600;
}

.spacer {
  flex: 1;
}

/* Вкладки — обводка волоском вокруг всей полосы и var(--bw) на активной, как
   на других переключателях интерфейса. */
/* Вкладок восемь, и в одну строку они помещаются только на широком экране:
   на телефоне их сумма вдвое шире полосы, а при nowrap хвост просто уезжал
   за край — «ИИ», «Цены», «Тарифы» и «Лайфхаки» были недостижимы. Перенос,
   а не горизонтальная прокрутка: прокрутку у полосы без видимого ползунка
   не находят, а так все вкладки на виду сразу. */
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  border-bottom: 1px solid var(--border);
}

.tab {
  padding: var(--sp-3) var(--sp-5);
  background: none;
  border: none;
  border-bottom: var(--bw) solid transparent;
  margin-bottom: -1px;
  color: var(--text-3);
  font-size: var(--fs-md);
  cursor: pointer;
}

.tab:hover {
  color: var(--text);
}

/* Неотвеченные сообщения поддержки — красный счётчик прямо в имени вкладки. */
.tabBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  margin-left: var(--sp-2);
  border-radius: 8px;
  background: var(--error);
  color: var(--text-inverse);
  font-size: var(--fs-xs);
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
}

.tabActive {
  color: var(--text);
  border-bottom-color: var(--focus);
  font-weight: 600;
}

.usersPanel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

.stats {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-4);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  min-width: 120px;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
}

.statValue {
  font-family: var(--font-mono);
  font-size: var(--fs-lg);
  color: var(--text);
}

.statLabel {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.toolbar {
  display: flex;
  gap: var(--sp-4);
}

.toolbar .input {
  max-width: 320px;
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  background: var(--error-bg);
  color: var(--error);
  box-shadow: var(--glow-error);
  font-size: var(--fs-sm);
}

/* Таблица шире экрана на телефоне — прокручивается сама, страница не едет. */
.tableWrap {
  overflow-x: auto;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-sm);
}

.table th,
.table td {
  padding: var(--sp-4) var(--sp-5);
  text-align: left;
  vertical-align: top;
  border-bottom: var(--bw) solid var(--border);
  white-space: nowrap;
}

.table th {
  font-weight: 600;
  color: var(--text-3);
  font-size: var(--fs-xs);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.table tbody tr:last-child td {
  border-bottom: 0;
}

.blockedRow {
  opacity: 0.6;
}

/* Заметнее приглушён, чем просто заблокированный: удаление — более далёкое
   от «активен» состояние, и в списке это должно читаться с первого взгляда. */
.deletedRow {
  opacity: 0.4;
  font-style: italic;
}

.email {
  display: block;
  color: var(--text);
}

.name {
  display: block;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.badgeWarn {
  display: inline-block;
  margin-top: var(--sp-2);
  padding: 0 var(--sp-3);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  background: var(--warn-bg);
  color: var(--warn);
  box-shadow: var(--glow-warn);
  font-size: var(--fs-xs);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
}

.empty {
  padding: var(--sp-7);
  text-align: center;
  color: var(--text-3);
}

.pager {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

.pageInfo {
  font-size: var(--fs-sm);
  color: var(--text-3);
}

.forbidden {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-5);
  color: var(--text-2);
}
